import moment from "moment";
import { sendEmail } from "./sendEmail";

const validationRules = {
    required: (value) => value !== undefined && value !== null && value !== '',
    minLength: (value, length) => value && value.length >= length,
    maxLength: (value, length) => value && value.length <= length,
    pattern: (value, regex) => value && regex.test(value),
};

export const validateForm = (formValue, schema) => {
    const errors = {};

    Object.keys(formValue).forEach((field) => {
        const value = formValue[field];
        const fieldRules = schema[field];

        if (fieldRules) {
            if (fieldRules.required && !validationRules.required(value)) {
                errors[field] = fieldRules.required.message;
            }

            if (fieldRules.pattern && !validationRules.pattern(value, fieldRules.pattern.regex)) {
                errors[field] = fieldRules.pattern.message;
            }

            if (fieldRules.minLength && !validationRules.minLength(value, fieldRules.minLength.length)) {
                errors[field] = fieldRules.minLength.message;
            }

            if (fieldRules.maxLength && !validationRules.maxLength(value, fieldRules.maxLength.length)) {
                errors[field] = fieldRules.maxLength.message;
            }
        }
    });

    return errors;
};

export const convertFirebaseTimestamp = (seconds, nanoseconds, format) => {
    const milliseconds = seconds * 1000;
    const totalMilliseconds = milliseconds + nanoseconds / 1e6;
    return moment(new Date(totalMilliseconds)).format(format ?? "DD-MM-YYYY")
}

export const getStatusColor = (status) => {
    switch (status) {
        case 'Done':
            return 'success';  // Green
        case 'OTP Done':
            return 'warning';   // Red
        case 'cancel':
            return 'danger';   // Red
        default:
            return 'secondary'; // Default Gray
    }
};

export const sendRegistrationEmail = async (user) => {
    const verificationLink = `${process.env.REACT_APP_COMPANY_LINK}/verification/${user?.id}`;

    const emailData = {
        sender: { email: process.env.REACT_APP_COMPANY_EMAIL },
        to: [{ email: user?.email }],
        subject: `Welcome to ${process.env.REACT_APP_COMPANY_NAME} | Confirm Your Registration`,
        htmlContent: `
            <div style="font-family: Arial, sans-serif; color: #333;">

                <h2>Welcome, ${user?.name}!</h2>

                <p>Thank you for registering with ${process.env.REACT_APP_COMPANY_NAME}.</p>

                <p>To complete your registration, please use the one-time password (OTP) below:</p>

                <h3 style="color: #4CAF50;">OTP: ${user?.otp}</h3>

                <p>You can complete your registration by visiting the following link:</p>

                <a href="${verificationLink}" style="color: #1a73e8; text-decoration: none;">Complete Your Registration</a>

                <p>If you didn’t request this, please ignore this email or contact support.</p>

                <p>Best Regards,<br>The ${process.env.REACT_APP_COMPANY_NAME} Team</p>
            </div>
        `,
        headers: {
            "X-Mailer": "CustomMailer 1.0",
        }
    };
    await sendEmail(emailData);
};

export const sendLoginDetailsEmail = async (user) => {
    const emailData = {
        sender: { email: process.env.REACT_APP_COMPANY_EMAIL },
        to: [{ email: user?.email }],
        subject: `Welcome to ${process.env.REACT_APP_COMPANY_NAME}`,
        htmlContent: `
            <div style="font-family: Arial, sans-serif; color: #333;">
                <h2 style="color: #4CAF50;">Hello ${user?.name},</h2>
                <p>Welcome to ${process.env.REACT_APP_COMPANY_NAME}! We're excited to have you on board.</p>
                <p>Here are your login credentials:</p>
                <ul style="list-style: none; padding-left: 0;">
                    <li><strong>Username:</strong> ${user?.email}</li>
                    <li><strong>Password:</strong> ${user?.number}</li>
                </ul>
                <p>To access your account, please visit: 
                <a href="${process.env.REACT_APP_COMPANY_LINK}" style="color: #1a73e8; text-decoration: none;">${process.env.REACT_APP_COMPANY_LINK}</a>
                </p>
                <p>Download your Agreement 
                <a href="${user?.pdfAgreementUrl}" style="color: #1a73e8; text-decoration: none;">${user?.pdfAgreementUrl}</a>
                </p>
                <p>If you have any questions or need assistance, feel free to reach out to us at <a href="mailto:${process.env.REACT_APP_COMPANY_EMAIL}" style="color: #1a73e8;">${process.env.REACT_APP_COMPANY_EMAIL}</a>.</p>
                <p>Thank you and welcome aboard!</p>
                <br>
                <p>Best Regards,</p>
                <p><strong>The ${process.env.REACT_APP_COMPANY_NAME} Team</strong></p>
                <hr style="border: none; border-top: 1px solid #ddd;">
                <p style="font-size: 0.9em; color: #777;">This is an automated email; please do not reply directly. If you didn't register with ${process.env.REACT_APP_COMPANY_NAME}, please ignore this email.</p>
            </div>
        `,
        headers: {
            "X-Mailer": "CompanyMailer 1.0"
        },
    };

    await sendEmail(emailData);
};


export const sendResendOtpEmail = async (user) => {
    const verificationLink = `${process.env.REACT_APP_COMPANY_LINK}/verification/${user?.id}`;

    const emailData = {
        sender: { email: process.env.REACT_APP_COMPANY_EMAIL },
        to: [{ email: user.email }],
        subject: `Welcome to ${process.env.REACT_APP_COMPANY_NAME} | User Re-Registration`,
        htmlContent: `
            <div>
                <p>Hello ${user?.name},</p>
                <p>Your agreement is reject due to some reason please click below link for Re-Registration</p>

                <p>OTP: ${user.otp},</p>

                <p>Use below OTP(one time password) to complete your registration</p>
                Link: ${verificationLink}
                
                <p>We understand your patient.</p>

                <p>Thanks and Regards,</p>
                <p>The ${process.env.REACT_APP_COMPANY_NAME} Team</p>
            </div>
        `,
    };

    await sendEmail(emailData);
};